import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { empty } from 'rxjs/observable/empty';

// import { getLoading, getErrorMessage } from '../../../store/reducers/ui.reducer';
import { State } from '../../../store/reducers';

import * as fromUI from '../../../store/actions/ui.action';
import * as fromBooking from '../../../store/actions/booking.action';
import { map } from 'rxjs/operators';
import { BookingService } from '../../services/booking.service';
import { country_list } from '../../../core/utilities/countries';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-add-booking',
  templateUrl: './add-booking.component.html',
  styleUrls: ['./add-booking.component.css']
})
export class AddBookingComponent implements OnInit {
  // checkListDetails$: Observable<any> = empty();
  countries: string[];
  availableRooms$: Observable<any>;
  loading$: Observable<boolean>;

  detailsFilled$: Observable<any>;
  selectedRoom$: Observable<any>;
  selectedTours$: Observable<any>;
  bookingPrice$: Observable<number>;

  errorMessage$: Observable<any>;
  bookingForm: FormGroup;

  tourPriceMap = {
    soweto: 50,
    'sun city': 75,
    'union building': 40,
    'gold reef city': 65
  };

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private store: Store<State>,
    private spinnerService: Ng4LoadingSpinnerService,
    public bookingService: BookingService
  ) {}

  ngOnInit() {
    this.countries = country_list;

    this.availableRooms$ = this.store.select(
      state => state.rooms.availableRooms
    );

    // this.checkListDetails$ = this.store.select(
    //   state => state.booking.currentBooking
    // );
  }

  // cumulateSelectedRoom(room) {
  //   this.bookingForm.get('selectedRoom').setValue(room.name);
  //   this.store.dispatch(new fromBooking.CollectSelectedRoom(room));
  // }

  // createBooking() {
  //   this.store.dispatch(new fromUI.PageLoading());
  //   this.spinnerService.show();
  //   this.loading$ = this.store.select(state => state.ui.loading);
  //   this.bookingPrice$.subscribe(price => {
  //     this.bookingForm.get('bookingPrice').setValue(price);
  //   });
  //   this.store.dispatch(new fromBooking.AddBooking(this.bookingForm.value));
  //   this.errorMessage$ = this.store.select(state => state.ui.error);
  // }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/containers/add-booking/add-booking.component.ts